export default __webpack_public_path__ + "static/media/i15.bb9cdada.jpg";